import _ from 'lodash';

export default function getAllDataInParallel({ fn, key } = {}) {
  return new Promise((resolve, reject) => {
    let data = []
    const resolveData = () => {
      resolve(
        _.omitBy({
          [key]: data,
          count: _.size(data),
          cacheChecksum: _.get(_.first(data), 'cacheChecksum'),
          query: _.get(_.first(data), 'query'),
        }, _.isUndefined)
      )
    }
    const fetchData = (otherPagesFn) => {
      const fetchNext = _.isFunction(otherPagesFn)
        ? otherPagesFn
        : () => fn({ pageCountless: false, pageSize: 999 })
      fetchNext()
        .then((result) => {
          // first page result
          if (_.has(result, key)) {
            const pageData = _.get(result, key, [])
            data = [
              ...data,
              ...pageData,
            ]
          }
          // other pages result
          if (_.isArray(result)) {
            data = [
              ...data,
              ..._.flatMap(result, key),
            ]
            resolveData()
          }
          // use `all` function to fetch other pages at once
          const all = _.get(result, 'all')
          if (_.isFunction(all)) {
            fetchData(all)
          } else {
            resolveData()
          }
        })
        .catch(reject)
    }

    fetchData()
  })
}
